/**
 * Reduced motion (F10.9): on when the system asks for it or the user turned on "Reduce motion"
 * in Settings (which sets data-motion="reduce" on <html>).
 */
export function prefersReducedMotion(): boolean {
  return (
    document.documentElement.dataset.motion === 'reduce' ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/** Applies the Settings choice; with it off, the system setting decides. */
export function applyMotion(reduce: boolean): void {
  if (reduce) document.documentElement.dataset.motion = 'reduce';
  else delete document.documentElement.dataset.motion;
}
